// import React, { useState, useEffect } from "react";
// import { FaRegUserCircle } from "react-icons/fa";
// import { NavLink } from "react-router-dom";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";

// import Pusher from "pusher-js";
// import Echo from "laravel-echo";

// const student = JSON.parse(localStorage.getItem("edo-student"));

// const Notification = () => {
//   const [notifications, setNotifications] = useState([]);
// // New state for banks API data
//   const userId = student ? student.student.id : "";
//   const [loading, setLoading] = useState(true); // Add loading state
//   useEffect(() => {
//     const fetchNotifications = async () => {
// //setIsLoading(true);; // Start loading before data fetch
//       try {
//         const response = await axios.get(
//           `${apiKey}/api/edolutions/student/notifications/${userId}`,
//           {
//             headers: {
//               Authorization: `Bearer ${student?.token}`,
//             },
//           }
//         );
//         setNotifications(response.data);
//       } catch (error) {
//         console.error("Error fetching notifications:", error);
//       } finally {
//         setLoading(false); // Stop loading after data fetch
//       }
//     };

//     fetchNotifications();
//   }, [userId]);



//   //broadcasting connection
//   useEffect(() => {
//     window.Pusher = Pusher;
  
//     window.Echo = new Echo({
//       broadcaster: 'pusher',
//       key: '301d873c1e8e09e9534c', // Pusher app key
//       cluster: 'ap2', // Pusher app cluster (e.g., 'eu')
//       forceTLS: true, // Pusher uses TLS by default
//       encrypted: true, // Ensures connection encryption
//       authEndpoint: `${apiKey}/broadcasting/auth`, // Same endpoint for Pusher
//       auth: {
//         headers: {
//           Authorization: `Bearer ${student?.token}`,
//         },
//       },
//     });
//     window.Echo.private("notification-read-event.student." + userId).listen(
//       "NotificationReadEvent",
//       (e) => {
//         setNotifications((prevNotif) => {
//           return [e.data, ...prevNotif];
//         });
//       }
//     );
//   }, [userId]);

//   return (
//     <div className="flex items-center xl:p-5 sm:p-0 justify-center">
//       <div className="w-full border rounded-3xl shadow-xl p-5">
//         <div>
//           <p className="text-2xl font-bold">Notifications</p>
//         </div>
//         <div className="flex border-b-2 justify-between items-center mt-8">
//           <div className="flex flex-wrap md:justify-start md:space-x-12 space-x-5 text-base font-medium">
//             <NavLink
//               to=".././notification"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B]"
//                   : undefined
//               }
//             >
//               All
//             </NavLink>

//             {/* <NavLink
//               to=".././newNotification"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               New
//             </NavLink> */}

//             {/* <NavLink
//               to=".././unreadNotification"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Unread
//             </NavLink> */}
//           </div>
//         </div>
//         {loading ? (
//           <div>
//             <div colSpan="9" className="py-5 px-1 text-center">
//               <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                 <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//                 <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//                   Cabil...
//                 </p>
//               </div>
//             </div>
//           </div>
//         ) : notifications.length === 0 ? (
//           <div>
//             <div colSpan="9" className="py-5 px-1 text-center">
//               <p className="text-gray-500">No Notification Available</p>
//             </div>
//           </div>
//         ) : (
//           notifications.map((notification) => (
//             <div
//               key={notification.id}
//               className="grid gap-4 my-4 bg-[#A3E7E11C] p-4"
//             >
//               <div className="flex gap-2">
//                 <div>
//                   <FaRegUserCircle className="h-8 w-8" />
//                 </div>
//                 <div>
//                   <p className="text-[#2D3748] capitalize text-[14px] font-semibold">
//                     {notification.message} ---- <span> {new Date(notification.created_at).toLocaleString()}</span>
//                   </p>
//                   <span className="text-[12px] text-[#2D3748]">
//                     {new Date(notification.created_at).toLocaleString()}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default Notification;

import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaRegUserCircle } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import axios from "axios";
import apiKey from "../../../config/apiKey";

import Pusher from "pusher-js";
import Echo from "laravel-echo";

const student = JSON.parse(localStorage.getItem("edo-student"));

const Notification = () => {
  const { t } = useTranslation();
  /* -------------------- PRESENTATION HELPERS (UI ONLY) -------------------- */
  const Page = ({ children }) => (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#FFF4EE] via-white to-[#E8F7F5]">
      <div className="mx-auto max-w-6xl px-4 py-8">{children}</div>
    </div>
  );

  const StickyHeader = () => (
    <div className="sticky top-0 z-10 -mx-4 mb-6 border-b border-[#F0F2F7] bg-white/80 backdrop-blur supports-[backdrop-filter]:backdrop-blur px-4 py-4">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl md:text-3xl font-black tracking-tight text-[#2A3A54]">
            {t("studentDash.notification.notifications")}
          </h1>
          <p className="text-xs text-gray-500">{t("studentDash.notification.subtitle")}</p>
        </div>
        <div className="flex items-center gap-6 text-sm font-semibold">
          <NavLink
            to=".././notification"
            className={({ isActive }) =>
              isActive
                ? "text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-2"
                : "text-gray-600 hover:text-[#2A3A54] pb-2"
            }
          >
            {t("studentDash.notification.all")}
          </NavLink>
        </div>
      </div>
    </div>
  );

  const Pill = ({ children, tone = "default" }) => {
    const tones = {
      default: "bg-gray-100 text-gray-700",
      new: "bg-[#FFF1EB] text-[#b5471e]",
      accepted: "bg-[#E8FFFB] text-[#0F766E]",
      declined: "bg-red-100 text-red-700",
    };
    return (
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold ${tones[tone]}`}
      >
        {children}
      </span>
    );
  };

  const TimelineItem = ({ n }) => (
    <div className="group relative pl-10">
      {/* line */}
      <div className="absolute left-[14px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#E2E8F0] to-transparent" />
      {/* dot */}
      <div className="absolute left-2 top-2 h-4 w-4 rounded-full ring-4 ring-white bg-[#2A3A54]" />

      <div className="rounded-xl border border-[#E9EDF3] bg-white/90 shadow-sm backdrop-blur p-4 hover:shadow-md transition">
        <div className="flex items-start gap-3">
          <div className="shrink-0">
            <FaRegUserCircle className="h-10 w-10 text-[#2A3A54]" />
          </div>
          <div className="flex-1">
            <p className="text-[14px] font-semibold text-[#2D3748] capitalize">
              {n.message}
            </p>

            <div className="mt-1 flex flex-wrap items-center gap-2">
              <span className="text-[12px] text-gray-500">
                {new Date(n.created_at).toLocaleString()}
              </span>

              {/* Status pills like teacher UI */}
              {!n.read && n.decline !== 1 && <Pill tone="new">{t("studentDash.notification.new")}</Pill>}
              {n.read === 1 && n.decline !== 1 && <Pill tone="accepted">{t("studentDash.notification.accepted")}</Pill>}
              {n.decline === 1 && <Pill tone="declined">{t("studentDash.notification.declined")}</Pill>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const Skeleton = () => (
    <div className="space-y-6">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="relative pl-10">
          <div className="absolute left-[14px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#E2E8F0] to-transparent" />
          <div className="absolute left-2 top-2 h-4 w-4 rounded-full ring-4 ring-white bg-gray-300" />
          <div className="animate-pulse rounded-xl border border-[#E9EDF3] bg-white p-4">
            <div className="flex items-start gap-3">
              <div className="h-10 w-10 rounded-full bg-gray-200" />
              <div className="flex-1 space-y-2">
                <div className="h-4 w-2/3 bg-gray-200 rounded" />
                <div className="h-3 w-40 bg-gray-200 rounded" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const Empty = () => (
    <div className="rounded-2xl border border-dashed border-[#E9EDF3] bg-white/70 p-10 text-center">
      <p className="text-gray-500">{t("studentDash.notification.noNotificationAvailable")}</p>
    </div>
  );

  /* ------------------------------ EXISTING LOGIC (UNCHANGED) ------------------------------ */
  const [notifications, setNotifications] = useState([]);
  const userId = student ? student.student.id : "";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          `${apiKey}/api/edolutions/student/notifications/${userId}`,
          { headers: { Authorization: `Bearer ${student?.token}` } }
        );
        setNotifications(response.data);
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchNotifications();
  }, [userId, student?.token]);

  // Pusher/Echo subscription (same channel/event, UI only changed)
  useEffect(() => {
    if (!userId) return;

    window.Pusher = Pusher;
    window.Echo = new Echo({
      broadcaster: "pusher",
      key: "301d873c1e8e09e9534c",
      cluster: "ap2",
      forceTLS: true,
      encrypted: true,
      authEndpoint: `${apiKey}/broadcasting/auth`,
      auth: {
        headers: { Authorization: `Bearer ${student?.token}` },
      },
    });

    const channelName = `notification-read-event.student.${userId}`;
    const channel = window.Echo.private(channelName);

    channel.listen("NotificationReadEvent", (e) => {
      setNotifications((prevNotif) => [e.data, ...prevNotif]);
    });

    return () => {
      try {
        channel.stopListening("NotificationReadEvent");
        window.Echo.leave(`private-${channelName}`);
      } catch {}
    };
  }, [userId, student?.token]);

  /* ---------------------------------- RENDER --------------------------------- */
  return (
    <Page>
      <StickyHeader />
      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        <div className="space-y-6">
          {loading ? (
            <Skeleton />
          ) : notifications.length === 0 ? (
            <Empty />
          ) : (
            notifications.map((n) => <TimelineItem key={n.id} n={n} />)
          )}
        </div>
      </div>
    </Page>
  );
};

export default Notification;
